import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, { parseFractionLikeInput, formatFractionLatexCore } from "../../../../components/inputs/FractionInput";
import { pick } from "../commonSolidPi";

export function generateTask() {
  const r = pick([3, 6, 9]);
  const k = (4 * r * r * r) / 3;
  return { type: "SphereRadiusFromVolumeTask", data: { r, k } };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginBottom: 12 }}>
      Objętość kuli jest równa <InlineMath math={`${data.k}\\pi`} />. Oblicz promień tej kuli.
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return <FractionInput value={userAnswer} onChange={onChange} disabled={disabled} label="r" placeholder="np. 6" />;
}

export function checkAnswer({ data }, userAnswer) {
  const parsed = Number.isFinite(userAnswer?.parsed) ? userAnswer.parsed : parseFractionLikeInput(userAnswer?.raw || "");
  return Number.isFinite(parsed) && Math.abs(parsed - data.r) <= 1e-6;
}

export function renderAnswer({ data }) {
  return <InlineMath math={`r=${data.r}`} />;
}

export function renderUserAnswer(userAnswer) {
  const raw = userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={`r=${formatFractionLatexCore(raw) || raw}`} />;
}

export function renderExplanation({ data }) {
  const { r, k } = data;
  return (
    <div style={{ display: "grid", rowGap: 8 }}>
      <p><strong>Krok 1.</strong> Zapisujemy wzór na objętość kuli.</p>
      <BlockMath math={`V=\\frac{4}{3}\\pi r^3`} />
      <p><strong>Krok 2.</strong> Podstawiamy dane i skracamy przez <InlineMath math={`\\pi`} />.</p>
      <BlockMath math={`${k}\\pi=\\frac{4}{3}\\pi r^3`} />
      <BlockMath math={`${k}=\\frac{4}{3}r^3`} />
      <p><strong>Krok 3.</strong> Wyznaczamy promień.</p>
      <BlockMath math={`r^3=${r * r * r}\\quad\\Rightarrow\\quad r=${r}`} />
      <p><strong>Odpowiedź:</strong> <InlineMath math={`r=${r}`} />.</p>
    </div>
  );
}
